import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MarketReportCampaign } from '../../domain';
import { MarketReportComparablePropertyComponent } from '../ui-market-report-comparable-property/market-report-comparable-property.component';

@Component({
  selector: 'rma-market-report-comparable-property-tiles',
  templateUrl: './market-report-comparable-property-tiles.component.html',
  styleUrls: ['./market-report-comparable-property-tiles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MarketReportComparablePropertyComponent],
})
export class MarketReportComparablePropertyTilesComponent {
  @Input()
  comparableCampaigns: MarketReportCampaign[] | null | undefined = [];

  @Input()
  selectedItemId: string | null | undefined;
}
